<script setup lang="ts">
import SectionHome from '@sections/section-home.vue';
import {storeToRefs} from "pinia";
import {useUserStore} from "@store/user";

//const testExpiredState = ref('active');

const userStore = useUserStore()
const {user} = storeToRefs(userStore);
</script>

<template>
	<main class="page">
		<section-home :user="user"></section-home>
	</main>
</template>
